import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    disabled: {
        userSelect: 'none',
        pointerEvents: 'none',
        opacity: 0.2,
    },
    dropdownElem: {
        fontSize: theme.typography.size.m,
    },
    errorSpacer: {
        height: theme.spacing(1.5),
    },
    errorWrapper: {
        height: 'fit-content',
        marginTop: 0,
        '& .spacer': {
            height: theme.spacing(1.5),
        },
    },
    error: {
        height: theme.spacing(1.5),
        fontSize: theme.spacing(1.25),
        marginLeft: 2,
        color: '#ff3c00',
    },
    errorColor: {
        color: '#ff3c00',
    },
    label: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: '160px',
        display: 'inherit',
        fontWeight: theme.typography.fontWeightRegular,
    },
    '& .MuiSelect-select': {
        fontSize: theme.spacing(2),
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        height: 'fit-content',
        alignItems: 'flex-start',
        marginTop: theme.spacing(2),

        '&: firstChild': {
            marginTop: '0',
        },
    },

    select: {
        fontSize: theme.typography.size.m,
        '&::before': {
            borderRadius: theme.dimensions.borderRadiusInput,
        },
    },
    selectBox: {
        background: theme.palette.background.neutral,
        fontSize: theme.typography.size.m,
        borderRadius: theme.dimensions.borderRadiusInput,
        width: '100%',

        '& > div': {
            padding: theme.spacing(1, 2),
            fontSize: theme.spacing(2),
        },
        '& .MuiInput-underline': {
            width: '100%',
            '&:before': {
                borderRadius: theme.dimensions.borderRadiusInput,
            },
        },
    },
    selectError: {
        fontSize: theme.typography.size.m,
        '&:before': {
            borderRadius: theme.dimensions.borderRadiusInput,
        },
    },
    value: {
        width: '100%',
        display: 'grid',
        '& div': {
            '& div': {
                position: 'unset !important',
                '& div.compact-picker': {
                    width: 'auto !important',
                    paddingTop: 'unset !important',
                    paddingLeft: 'unset !important',
                    '& div.flexbox-fix': {
                        display: 'none !important',
                    },
                    '& div': {
                        '& span': {
                            '& div': {
                                border: `1px solid ${theme.palette.text.primary}`,
                                borderRadius: '5px',
                            },
                        },
                    },
                },
            },
        },
    },
}));

export default useStyles;
